import { render } from "./PreavisConfirmationCreatedModal.vue?vue&type=template&id=44021681&scoped=true&ts=true"
import script from "./PreavisConfirmationCreatedModal.vue?vue&type=script&lang=ts"
export * from "./PreavisConfirmationCreatedModal.vue?vue&type=script&lang=ts"

import "./PreavisConfirmationCreatedModal.vue?vue&type=style&index=0&id=44021681&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-44021681"]])

export default __exports__